export const navLinks = [
  { id: 'tracking', label: '系列追踪' },
  { id: 'compare', label: '同类对比' },
  { id: 'cases', label: '案例合集' },
  { id: 'analysis', label: '横向分析' },
  { id: 'topics', label: '主题分类' },
  { id: 'faq', label: '常见问题' },
];

export const heroStats = [
  { value: '1,280+', label: '收录案例' },
  { value: '86', label: '在追线索' },
  { value: '240', label: '对比组' },
  { value: '12', label: '主题大类' },
];

export const focusAreas = [
  {
    icon: 'ri-time-line',
    title: '系列爆料追踪',
    desc: '把同一条线索下的零散消息按时间顺序串起来，从首次浮现到后续回应，脉络一次看清。',
    tag: '时间轴',
  },
  {
    icon: 'ri-scales-3-line',
    title: '同类事件对比',
    desc: '把性质相近的事件并排放在一起，对照触发原因、回应方式与结果走向，找出共性规律。',
    tag: '对照表',
  },
  {
    icon: 'ri-stack-line',
    title: '相似案例合集',
    desc: '按主题把相似案例聚合归档，需要找参照的时候，可以直接从同一类里取用。',
    tag: '案例库',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: '横向比较分析',
    desc: '用多维度指标衡量不同事件的传播范围、持续周期与信息完整度，差异一目了然。',
    tag: '指标化',
  },
];

export const trackingSteps = [
  {
    time: '第 1 天',
    title: '线索首次浮现',
    desc: '一条来源有限的爆料出现在公开渠道，信息零散，仅提到规则调整的方向，尚未有细节。',
    status: '待核实',
  },
  {
    time: '第 3 天',
    title: '多方补充爆料',
    desc: '数位从业者从不同角度补充细节，交叉验证后，调整范围与生效时间逐渐清晰。',
    status: '交叉验证',
  },
  {
    time: '第 5 天',
    title: '相关方首次回应',
    desc: '涉事方向外界作出简短说明，承认存在调整，但未公布完整规则与过渡安排。',
    status: '已回应',
  },
  {
    time: '第 9 天',
    title: '细则逐步落地',
    desc: '调整后的具体口径被陆续披露，受影响的群体开始据此重新评估自身收益结构。',
    status: '细则披露',
  },
  {
    time: '第 15 天',
    title: '波及同类主体',
    desc: '相似规则在同类平台上被讨论，事件由单点问题扩散为行业内共通的议题。',
    status: '范围扩散',
  },
  {
    time: '第 21 天',
    title: '横向复盘对比',
    desc: '把本次事件与过去几次同类规则调整并排比较，总结出应对节奏上的规律。',
    status: '已复盘',
  },
];

export const comparisonColumns = [
  { key: 'cause', label: '触发原因' },
  { key: 'cycle', label: '发酵周期' },
  { key: 'responder', label: '主要回应方' },
  { key: 'method', label: '回应方式' },
  { key: 'result', label: '结果走向' },
  { key: 'heat', label: '关注热度' },
];

export const comparisonEvents = [
  {
    name: '创作者分成规则调整',
    period: '2024 · 春',
    highlight: true,
    cause: '平台调整收益结算口径',
    cycle: '约 21 天',
    responder: '平台方 + 从业者',
    method: '先简短说明，后补细则',
    result: '细则落地，过渡期安排出台',
    heat: 82,
  },
  {
    name: '平台佣金比例变更',
    period: '2024 · 夏',
    highlight: false,
    cause: '商家综合成本上升',
    cycle: '约 14 天',
    responder: '平台方为主',
    method: '公告 + 客服口径说明',
    result: '部分费率回调，配套补贴跟进',
    heat: 68,
  },
  {
    name: '会员权益条款调整',
    period: '2025 · 初',
    highlight: false,
    cause: '权益边界重新界定',
    cycle: '约 26 天',
    responder: '平台方 + 用户社群',
    method: '条款更新 + 答疑专场',
    result: '争议条款暂缓，进入讨论期',
    heat: 74,
  },
];

export const topicTabs = [
  { id: 'all', label: '全部案例' },
  { id: 'content', label: '文娱内容' },
  { id: 'commerce', label: '直播电商' },
  { id: 'brand', label: '品牌营销' },
  { id: 'sports', label: '体育赛场' },
  { id: 'tech', label: '科技发布' },
];

export const caseList = [
  {
    id: 'case-1',
    category: 'content',
    categoryLabel: '文娱内容',
    title: '短视频平台创作者分成规则调整',
    summary: '从一条来源有限的爆料开始，21 天内走过回应、细则落地到行业复盘的完整链路，是典型的单点规则变化引发连锁讨论的案例。',
    date: '2024.03',
    heat: 82,
    status: '已复盘',
    tags: ['规则调整', '收益结算'],
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20smartphone%20screen%20with%20rising%20bar%20charts%20and%20torn%20paper%20strips%2C%20crimson%20and%20amber%20accents%20on%20a%20warm%20cream%20background%2C%20minimal%20geometric%20shapes%2C%20magazine%20infographic%20aesthetic%2C%20no%20text&width=800&height=600&seq=bkd-case-01&orientation=landscape',
  },
  {
    id: 'case-2',
    category: 'commerce',
    categoryLabel: '直播电商',
    title: '头部主播选品争议事件',
    summary: '选品口径与宣传描述之间的落差被逐步放大，前后共出现三轮回应，最终以公开整改说明收尾。',
    date: '2024.06',
    heat: 91,
    status: '跟踪中',
    tags: ['选品争议', '宣传口径'],
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20microphone%20and%20shopping%20cart%20icon%20merged%20with%20warning%20triangles%2C%20crimson%20and%20amber%20palette%20on%20warm%20cream%20background%2C%20minimal%20geometric%20composition%2C%20magazine%20infographic%20aesthetic%2C%20no%20text&width=800&height=600&seq=bkd-case-02&orientation=landscape',
  },
  {
    id: 'case-3',
    category: 'brand',
    categoryLabel: '品牌营销',
    title: '国货品牌年度代言合约更迭',
    summary: '代言关系调整在短时间内集中释放，横向对比三次同类更迭，可以发现节奏与话术高度相似。',
    date: '2024.09',
    heat: 64,
    status: '已复盘',
    tags: ['代言更迭', '合作节奏'],
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20two%20handshake%20icons%20and%20a%20rotating%20contract%20document%2C%20crimson%20and%20amber%20accents%20on%20warm%20cream%20background%2C%20minimal%20geometric%20shape%20composition%2C%20editorial%20magazine%20aesthetic%2C%20no%20text&width=800&height=600&seq=bkd-case-03&orientation=landscape',
  },
  {
    id: 'case-4',
    category: 'sports',
    categoryLabel: '体育赛场',
    title: '职业联赛判罚争议复盘',
    summary: '围绕单场判罚的讨论迅速聚焦到规则解释层面，与过往两次同类争议放在一起看，争议焦点几乎重合。',
    date: '2024.11',
    heat: 77,
    status: '已复盘',
    tags: ['判罚争议', '规则解释'],
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20whistle%20and%20a%20scoreboard%20with%20debate%20speech%20bubbles%2C%20crimson%20and%20amber%20palette%20on%20warm%20cream%20background%2C%20minimal%20geometric%20composition%2C%20editorial%20magazine%20aesthetic%2C%20no%20text&width=800&height=600&seq=bkd-case-04&orientation=landscape',
  },
  {
    id: 'case-5',
    category: 'tech',
    categoryLabel: '科技发布',
    title: '新机发布前参数泄露事件',
    summary: '发布前两周围绕参数的爆料反复出现，逐条比对后，泄露内容与最终规格的吻合度被完整记录。',
    date: '2025.01',
    heat: 59,
    status: '跟踪中',
    tags: ['参数泄露', '发布节奏'],
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20smartphone%20outline%20with%20spec%20cards%20and%20an%20open%20envelope%2C%20crimson%20and%20amber%20accents%20on%20warm%20cream%20background%2C%20minimal%20geometric%20composition%2C%20editorial%20magazine%20aesthetic%2C%20no%20text&width=800&height=600&seq=bkd-case-05&orientation=landscape',
  },
  {
    id: 'case-6',
    category: 'content',
    categoryLabel: '文娱内容',
    title: '网络综艺剪辑争议发酵过程',
    summary: '成片呈现与录制现场描述的落差引发讨论，对比三档同类综艺，剪辑争议的爆发点往往出现在同一环节。',
    date: '2025.03',
    heat: 70,
    status: '已复盘',
    tags: ['剪辑争议', '成片呈现'],
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20film%20clapperboard%20with%20scissors%20cutting%20film%20strips%2C%20crimson%20and%20amber%20palette%20on%20warm%20cream%20background%2C%20minimal%20geometric%20composition%2C%20editorial%20magazine%20aesthetic%2C%20no%20text&width=800&height=600&seq=bkd-case-06&orientation=landscape',
  },
  {
    id: 'case-7',
    category: 'content',
    categoryLabel: '文娱内容',
    title: '剧集番位排序引发讨论',
    summary: '宣传物料的排序差异被细心观众发现，与过去两次同类排序讨论相比，这次的发酵更快、周期更短。',
    date: '2025.05',
    heat: 61,
    status: '已复盘',
    tags: ['番位排序', '宣传物料'],
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20stacked%20name%20plates%20and%20ranking%20arrows%2C%20crimson%20and%20amber%20accents%20on%20warm%20cream%20background%2C%20minimal%20geometric%20composition%2C%20editorial%20magazine%20aesthetic%2C%20no%20text&width=800&height=600&seq=bkd-case-07&orientation=landscape',
  },
  {
    id: 'case-8',
    category: 'commerce',
    categoryLabel: '直播电商',
    title: '大促价格机制质疑事件',
    summary: '大促期间的价格标注方式被反复追问，横向对照三次大促，同一类质疑出现的时点几乎一致。',
    date: '2025.06',
    heat: 85,
    status: '跟踪中',
    tags: ['价格机制', '大促节奏'],
    image: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20price%20tag%20with%20a%20magnifying%20glass%20and%20rising%20percentage%20arrows%2C%20crimson%20and%20amber%20palette%20on%20warm%20cream%20background%2C%20minimal%20geometric%20composition%2C%20editorial%20magazine%20aesthetic%2C%20no%20text&width=800&height=600&seq=bkd-case-08&orientation=landscape',
  },
];

export const analysisMetrics = [
  {
    label: '影响范围',
    desc: '事件波及的群体与平台数量',
    values: [
      { name: '创作者分成调整', score: 88 },
      { name: '佣金比例变更', score: 72 },
      { name: '会员权益调整', score: 65 },
      { name: '大促价格质疑', score: 80 },
    ],
  },
  {
    label: '持续周期',
    desc: '从首次爆料到舆情回落的时长',
    values: [
      { name: '创作者分成调整', score: 76 },
      { name: '佣金比例变更', score: 58 },
      { name: '会员权益调整', score: 84 },
      { name: '大促价格质疑', score: 62 },
    ],
  },
  {
    label: '信息完整度',
    desc: '关键信息被交叉验证的程度',
    values: [
      { name: '创作者分成调整', score: 90 },
      { name: '佣金比例变更', score: 70 },
      { name: '会员权益调整', score: 61 },
      { name: '大促价格质疑', score: 74 },
    ],
  },
  {
    label: '可复盘价值',
    desc: '对同类事件参照借鉴的意义',
    values: [
      { name: '创作者分成调整', score: 92 },
      { name: '佣金比例变更', score: 68 },
      { name: '会员权益调整', score: 71 },
      { name: '大促价格质疑', score: 79 },
    ],
  },
];

export const categoryGroups = [
  { icon: 'ri-film-line', name: '文娱内容', count: 386, desc: '分成规则、番位排序、剪辑呈现等' },
  { icon: 'ri-shopping-bag-3-line', name: '直播电商', count: 254, desc: '选品口径、价格机制、售后争议' },
  { icon: 'ri-megaphone-line', name: '品牌营销', count: 198, desc: '代言更迭、联名节奏、宣传话术' },
  { icon: 'ri-trophy-line', name: '体育赛场', count: 142, desc: '判罚解释、赛程安排、结果复核' },
  { icon: 'ri-smartphone-line', name: '科技发布', count: 176, desc: '参数泄露、发布节奏、宣传口径' },
  { icon: 'ri-tv-2-line', name: '网络综艺', count: 124, desc: '剪辑争议、赛制调整、呈现落差' },
];

export const faqList = [
  {
    q: '爆料看点主要收录哪些类型的案例？',
    a: '我们聚焦于有"可对比价值"的事件，覆盖文娱内容、直播电商、品牌营销、体育赛场、科技发布与网络综艺等主题。判断标准不是热度高低，而是这件事能否放进一组同类事件里做横向参照。',
  },
  {
    q: '系列爆料追踪和普通新闻有什么区别？',
    a: '普通新闻通常只呈现某一个时间点。系列爆料追踪会把同一条线索下的多次爆料按时间顺序串成一条线，记录每次信息增量、各方回应以及最终走向，让你能看清事件是怎么一步步发展的。',
  },
  {
    q: '同类事件对比的依据是什么？',
    a: '我们主要对照五个维度：触发原因、发酵周期、主要回应方、回应方式与结果走向。只有在这几个维度上具备可比性的事件，才会被放进同一组对照表，避免把不相干的事情硬凑在一起。',
  },
  {
    q: '相似案例合集是如何筛选出来的？',
    a: '会先按主题归类，再根据信息完整度、可复盘价值和后续影响进行排序。信息残缺或无法交叉验证的案例会标注状态，不会与已经核实的案例混在一起呈现。',
  },
  {
    q: '案例内容会不会涉及个人隐私？',
    a: '不会。我们在整理案例时以事件脉络和公开信息为主，不展示、不传播与事件无关的个人身份信息。如果某条线索无法在公开层面核实，我们只做状态标注，不做推测性描述。',
  },
  {
    q: '如何投递自己的线索？',
    a: '可以在页面底部的线索投递区提交。请尽量说明事件的大致时间、涉及的主体类型以及你认为值得关注的原因，信息越具体，我们越容易判断它属于哪一组对比线索。',
  },
];

export const testimonials = [
  {
    name: '从业者 · 内容运营',
    text: '以前遇到类似的规则调整，只能靠记忆去比较，现在可以直接在对照表里看到几次事件的节奏差异，复盘效率高了很多。',
    role: '内容运营',
  },
  {
    name: '观察者 · 行业研究员',
    text: '最有价值的是信息完整度的标注，哪些已经交叉验证、哪些还停留在单方说法，一眼就能分辨，不用自己去猜可信度。',
    role: '行业研究员',
  },
  {
    name: '使用者 · 自媒体创作者',
    text: '写稿前会先来翻一下同类案例合集，找参照物特别快，而且不会被过时的细节带偏，省了很多重复核对的时间。',
    role: '自媒体创作者',
  },
];

export const principles = [
  {
    icon: 'ri-link-m',
    title: '线索优先',
    desc: '先判断事件属于哪条线索，再决定呈现方式，避免把碎片消息当成独立结论。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '可核实为底线',
    desc: '信息未经交叉验证的，只做状态标注，不写成确定结论。',
  },
  {
    icon: 'ri-eye-line',
    title: '对比而非评判',
    desc: '我们提供维度与事实，帮助你看清差异，而不是替你下定论。',
  },
];